import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';

import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';

import {CoreModule} from '../../core/core.module';

import {UserRestApiService} from './services/http/user-rest-api.service';
import {UsersListComponent} from './users-list/users-list.component';
import {CreateUserComponent} from './create-user/create-user.component';
import {UserComponent} from './user.component';
import {SharedModule} from '../../shared/shared.module';
import {EditUserComponent} from './edit-user/edit-user.component';

@NgModule({
  declarations: [
    UserComponent,
    UsersListComponent,
    CreateUserComponent,
    EditUserComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    ReactiveFormsModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatIconModule,
    MatCheckboxModule,

    SharedModule,
    CoreModule,
  ],
  providers: [
    UserRestApiService,
  ],
})
export class UserModule {
}
